// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import './index.css';
import HomePage from "./pages/HomePage";
// import Landing from "./pages/Landing"
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from './pages/Dashboard';
import EditBoard from "./pages/EditBoard";
import ViewBoard from "./pages/ViewBoard";
import Profile from "./pages/Profile";
import Billing from "./pages/Billing";
import Company from "./pages/Company";
import Layout from "./layouts/Layout";
import Header from "./components/Header/Header"
import Footer from "./components/Footer/Footer";
import ThemeProvider from "./providers/ThemeProvider";
import ScrollToTop from "./providers/ScrollToTop";
import { AuthProvider } from './providers/AuthContext';
import ProtectedRoute from './providers/ProtectedRoute';
import RedirectIfLoggedIn from './providers/RedirectIfLoggedIn';
import DownloadPDF from "./pages/DownloadPDF";
import AcceptInvite from "./pages/AcceptInvite";


function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
          <Router>
            <Header />
            <Layout>
            <ScrollToTop>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/demo" element={<HomePage cta="demo" />} />
                <Route path="/download" element={<DownloadPDF />} />
                <Route element={<RedirectIfLoggedIn />}>
                  <Route path="/login" element={<Login />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                </Route>
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/accept-invite" element={<AcceptInvite />} />
                <Route element={<ProtectedRoute />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/profile" element={<Profile />} />                
                  <Route path="/board/:company_slug/:board_slug/edit" element={<EditBoard />} />
                  <Route path="/billing" element={<Billing />} />
                  <Route path="/company" element={<Company />} />
                </Route>
                <Route path="/board/:company_slug/:board_slug" element={<ViewBoard />} />
              </Routes>
              </ScrollToTop>
            </Layout>
            <Footer />
          </Router>
      </ThemeProvider>
    </AuthProvider>  
  );
}

export default App;